import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = {
    listingId: String,
    section: String,
    url: String,
    reloadOnReady: Boolean
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  async startPolling() {
    // Only start polling if there's a loading spinner inside this element
    if (!this.element.querySelector(".animate-spin")) {
      return
    }

    this.pollCount = 0
    this.maxPolls = 30 // ~1 minute at 2s intervals
    this.poll()
  }

  pollUrl() {
    if (this.urlValue && this.urlValue.length > 0) {
      const sep = this.urlValue.includes("?") ? "&" : "?"
      return this.sectionValue ? `${this.urlValue}${sep}section=${this.sectionValue}` : this.urlValue
    }
    return `/listings/${this.listingIdValue}/data_status?section=${this.sectionValue}`
  }

  async poll() {
    if (this.pollCount >= this.maxPolls) {
      console.log(`listing-poller: stopped after ${this.maxPolls} attempts`)
      return
    }

    try {
      const response = await get(this.pollUrl(), { responseKind: this.reloadOnReadyValue ? "json" : "turbo-stream" })

      if (response.statusCode === 204) {
        this.pollCount++
        this.pollTimer = setTimeout(() => this.poll(), 2000)
      } else if (response.ok) {
        this.stopPolling()
        if (this.reloadOnReadyValue) {
          if (window.Turbo) {
            Turbo.visit(window.location.href, { action: "replace" })
          } else {
            window.location.reload()
          }
        }
      } else {
        this.pollCount++
        this.pollTimer = setTimeout(() => this.poll(), 2000)
      }
    } catch (error) {
      console.error("listing-poller: error", error)
      this.pollCount++
      this.pollTimer = setTimeout(() => this.poll(), 2000)
    }
  }

  stopPolling() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
      this.pollTimer = null
    }
  }
}
